"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInstance = void 0;
var watch_1 = require("../watch");
var proxy_1 = require("../proxy");
var iframe_1 = require("./iframe");
var storage_1 = require("./storage");
var instance = false;
function getChannelFromParam(param) {
    return param.substring(param.indexOf('[') + 1, param.indexOf(']'));
}
function replayServerSideLogs(receivedBuffer) {
    if (!instance) {
        return;
    }
    var watchedChannels = storage_1.BrowserStorage.loadList();
    receivedBuffer.forEach(function (item) {
        var callable = console[item.method];
        if (item.params.length > 0 && watchedChannels.length > 0) {
            var channel = getChannelFromParam(item.params[0]);
            if (watchedChannels.includes(channel)) {
                callable.apply(void 0, __spreadArrays(['[SSR]'], item.params));
            }
        }
    });
}
function createInstance() {
    var watcher = new watch_1.ChannelWatch(storage_1.BrowserStorage);
    var watch = watcher.watch, unwatch = watcher.unwatch, watching = watcher.watching;
    var proxy = new proxy_1.Proxy(console, watching);
    var error = proxy.error, warn = proxy.warn, info = proxy.info, log = proxy.log, trace = proxy.trace, createLogger = proxy.createLogger, list = proxy.list, alert = proxy.alert, alertOnError = proxy.alertOnError;
    var selfLogger = proxy.createLogger('ddt');
    iframe_1.initIframeSync(selfLogger, watcher);
    return {
        watch: watch,
        unwatch: unwatch,
        watching: watching,
        error: error,
        warn: warn,
        info: info,
        log: log,
        trace: trace,
        createLogger: createLogger,
        list: list,
        replayServerSideLogs: replayServerSideLogs,
        alert: alert,
        alertOnError: alertOnError,
    };
}
function getClientInstance() {
    if (!instance) {
        instance = createInstance();
        window.ddt = instance;
    }
    return instance;
}
exports.getClientInstance = getClientInstance;
//# sourceMappingURL=index.js.map